import {useMutation} from "@apollo/client";
import {toast} from "react-hot-toast";

import {FormModal} from "@/components/form/overlay/FormModal.tsx";
import {
  GQL_STATUS_PAGE_QUERY,
  GQL_STATUSPAGE_COMPONENTS,
  GQL_UPDATE_COMPONENT,
  UpdateComponentResult,
} from "@/lib/queries/statuspages.ts";
import {Component} from "@/lib/types/statuspages.ts";
import StatusPageUpdateGroupComponentForm from "@/pages/statuspages/tabs/components/componentGroupModal/StatusPageUpdateGroupComponentForm.tsx";

interface StatusPageComponentGroupUpdateModalProps {
  statusPageID: number;
  component?: Component;
  defaultComponents?: Component[];
  show: boolean;
  setShow: (show: boolean) => void;
}

interface StatusPageComponentGroupUpdateFormValues {
  id?: number;
  name: string;
  description: string;
}

export const StatusPageComponentGroupUpdateModal = ({
  statusPageID,
  component,
  defaultComponents,
  show,
  setShow,
}: StatusPageComponentGroupUpdateModalProps) => {
  const [updateComponent, {data, loading}] = useMutation<UpdateComponentResult>(GQL_UPDATE_COMPONENT, {
    refetchQueries: [GQL_STATUS_PAGE_QUERY, GQL_STATUSPAGE_COMPONENTS],
  });
  const formId = "addNewGroupComponent";
  const handleSubmit = async (data: StatusPageComponentGroupUpdateFormValues) => {
    const response = await updateComponent({
      variables: {
        statusPageID: statusPageID,
        data: {
          ...data,
          is_group: true,
        },
      },
    });
    setShow(!response?.data?.updateComponent?.success);
    if (response?.data?.updateComponent?.success) {
      const toastMessage = component ? "Component Group updated." : "Component Group created.";
      toast.success(toastMessage);
    }
  };

  return (
    <FormModal
      className="px-2"
      size="lg"
      disabled={loading}
      formId={formId}
      hasRequiredFields
      onCancel={() => setShow(false)}
      show={show}
      submitBtnText={`${component ? "Save Changes" : "Create Group"}`}
      title={`${component ? "Edit" : "Create"} Component Group`}
      placement="end"
    >
      <StatusPageUpdateGroupComponentForm
        component={component}
        statusPageId={statusPageID}
        id={formId}
        serverErrors={data?.updateComponent?.errors}
        onSubmit={handleSubmit}
        defaultComponents={defaultComponents}
      />
    </FormModal>
  );
};
